var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 40.5v-12C0 15.655 5.979 6.345 18.171 3.078A2.25 2.25 0 0121 5.253V8.43c0 .943-.584 1.794-1.47 2.114C13.341 12.78 9.75 17.057 9.75 24h6.75a4.5 4.5 0 014.5 4.5v12a4.5 4.5 0 01-4.5 4.5h-12A4.5 4.5 0 010 40.5zM31.5 45h12a4.5 4.5 0 004.5-4.5v-12a4.5 4.5 0 00-4.5-4.5h-6.75c0-6.943 3.592-11.22 9.78-13.456A2.243 2.243 0 0048 8.43V5.253a2.25 2.25 0 00-2.829-2.175C32.98 6.345 27 15.655 27 28.5v12a4.5 4.5 0 004.5 4.5z"
  })));
};
export default SvgQuote;